// extracted by mini-css-extract-plugin
module.exports = {"orderPlaced":"HH","page":"IH","container":"JH","spcWrapper":"KH","chargeSummaryWrapper":"LH"};